import React, { memo } from 'react'

import { bool, func } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import AiTermsNotice from '../AiTermsNotice/AiTermsNotice'
import UpgradeCard from '../UpgradeCard/UpgradeCard'

function UpgradeBody({ onClose: handleClose, showAdvancedFeaturesList = false }) {
  const t = useTranslation()

  const title = showAdvancedFeaturesList
    ? t('usageModal.paidFeature.title')
    : t('usageModal.upgrade.title')

  return (
    <div className="usage-modal__upgrade">
      <UpgradeCard onClose={handleClose} title={title} showAdvancedFeaturesList={showAdvancedFeaturesList} />

      <AiTermsNotice />
    </div>
  )
}

UpgradeBody.propTypes = {
  onClose: func.isRequired,
  showAdvancedFeaturesList: bool,
}

export default memo(UpgradeBody)
